<template>
  <div>
    <div class="clearfix"></div>
    <div class="row">
      <div class="col-md-12 col-sm-12 col-xs-12">
        <div class role="tabpanel">
          <ul id="creditsTabs" class="nav nav-tabs bar_tabs pull-right" role="tablist">
            <li role="presentation" class>
              <a href="#statisticsTab" data-toggle="tab">
                <i class="fas fa-chart-area"></i> Statistics
              </a>
            </li>
            <li role="presentation" :class="{'bold loadedFileActive': loadedCreditStatus }">
              <a href="#detailTab" data-toggle="tab" @click="loadedCreditStatus = false">
                <i class="fas fa-info-circle"></i>
                Credit transaction details {{ loadedCreditId }}
              </a>
            </li>
            <li role="presentation" class="active">
              <a href="#overviewTab" data-toggle="tab">
                <i class="fas fa-table"></i> Overview
              </a>
            </li>
          </ul>
          <div id="creditsTabContent" class="tab-content">
            <div class="tab-pane active" id="overviewTab">
              <div class="card">
                <div class="card-content">
                  <v-server-table
                    :url="dataUrl"
                    :columns="columns"
                    :options="options"
                    ref="creditTable"
                  >
                    <template slot="type" slot-scope="props">
                      <div class="tableAction">
                        <span v-if="props.row.status === 'PAID'">PAID</span>
                        <span v-if="props.row.status === 'PENDING'">PENDING</span>
                        <span v-if="props.row.status === 'CANCELED'">CANCELED</span>
                        <span v-else> | {{props.row.type}}</span>
                      </div>
                    </template>
                    <template slot="amount" slot-scope="props">
                        <span>{{ ws.getSetting('currency_symbol') }} {{props.row.amount}}</span>
                    </template>
                    <template slot="actions" slot-scope="props">
                      <div class="tableAction">
                        <span v-if="props.row.status === 'PAID'">
                          <a
                            class="btn btn bg-blue"
                            @click="downloadInvoice(props.row.id)"
                            data-tooltip="Download invoice"
                          >
                            <i class="fas fa-file-invoice-dollar"></i>
                          </a>
                        </span>
                        <span v-else>
                          <a
                            class="btn btn bg-blue"
                            @click="completePayment(props.row.url)"
                            data-tooltip="Complete payment"
                          >
                            <i class="fas fa-check-circle"></i>
                          </a>
                        </span>
                      </div>
                    </template>
                  </v-server-table>
                  <div class="clearfix"></div>
                </div>
              </div>
            </div>
            <div class="tab-pane" id="detailTab">
              <creditdetails
                :creditId="loadedCreditId"
                ref="creditEditor"
                :loadedCreditId.sync="loadedCreditId"
                :loadedCreditStatus.sync="loadedCreditStatus"
                v-on:creditSaved="reloadTable()"
              ></creditdetails>
            </div>
            <div class="tab-pane" id="buyTab">
              <buycredits></buycredits>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Creditdetails from "../../components/credit";
import Buycredits from "../../components/buycredit";
export default {
  components: {
    Creditdetails,
    Buycredits
  },
  data: function() {
    return {
      creditLoaded: "",
      loadingData: false,
      deleted_filter: false,
      date_start_filter: "",
      date_end_filter: "",
      loadedCreditStatus: false,
      loadedCreditId: -1,
      dataUrl: APIURL + "/transactions",
      modalId: "prevModal",
      modalTitle: "modalTitle",
      modalBody: "modalBody",
      modalButtons: ["close"],
      options: {
        perPage: 20,
        headings: {type: 'Status & Type', trx: 'Transaction code'},
        headingsTooltips: {trx: 'This transaction code can be linked to the transaction with your payment provider', actions: 'When a payment is completed, you can download the invoice. Otherwise, you can complete a payment by clicking the button.'}
      },
      columns: ["created_at", "type", "credits", "amount", "trx", "actions"]
    };
  },
  methods: {
    reloadTable() {
      this.$refs.creditTable.customQueries[
        "show_deleted"
      ] = this.deleted_filter;
      this.$refs.creditTable.getData();

      $("html, body").animate({ scrollTop: 0 }, "fast");
      this.loadedCreditStatus = false;
      $('.nav-tabs a[href="#overviewTab"]').tab("show");
    },
    editRow(creditId) {
      this.loadedCreditStatus = true;
      var creditEditor = this.$refs.creditEditor;
      this.loadedCreditId = creditId;
      creditEditor.loadCreditDetails(creditId);
      $('.nav-tabs a[href="#detailTab"]').tab("show");
    },
    completePayment(url) {
      if (typeof(url) === "undefined") {
        this.$notify({
          component: {
            template: 
            `<span>Something went wrong, please try again by pressing F5 and make a new payment</span>`
          },
          icon: "fas fa-error",
          type: "warning"
        });
      } else {
        window.location.href = url;
        this.$notify({
          component: {
            template: `<span>Your browser is being redirected to our payment provider. Please stand by...</span>`
          },
          icon: "fas fa-check",
          type: "success"
        });
      }
    },
    downloadInvoice(transactionId) {
      if (typeof transactionId !== "undefined") {
        this.$notify({
          component: {
            template:
              `<span>Downloading your transaction (PDF), this may take a while.</span>`
          },
          icon: "fas fa-check",
          type: "success"
        });

        Webservice.getInvoice(transactionId).then((resp) => {
          if(resp.headers) {
              var headers = resp.headers;
              var a = document.createElement('a');
              let contenttype = resp.headers["content-type"];
              
              var blob = new Blob([resp.data], {type: contenttype});
              var url = window.URL.createObjectURL(blob);

              a.style = "display: none";  
              a.href = url;
              a.download = 'invoice_' + transactionId + '.pdf';

              document.body.appendChild(a);
              a.click();
              setTimeout(function(){
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);  
            }, 1500);
          }
        });
      }
    }
  },
  computed: {
      ws: () => { return Webservice; }
    }
};
</script>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/Transactions/Overview.vue